
import { finalize, tap } from 'rxjs/operators';

import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal, NgbModalRef } from '@otas/modal/modal-ref';
import { UntypedFormBuilder, FormGroup } from '@angular/forms';
import { Thulabharam } from '@otas/model/thulabharam';
import { AppConstants } from '../../../app.constants';
import { AddPaymentModalService } from './add-payment-modal.service';
import moment from 'moment';
import { GlobalData } from '../../../globalData';
import { ConfirmModalService } from '@otas/shared/confirm-modal/confirm-modal.component';
import { GlobalUtilService } from '@otas/core/services/global-util.service';

import { PaymentResponseObj } from '@otas/model/payment/payment-response';
import { InvoiceDetails } from '@otas/model/payment/transaction';
import { ToasterService } from '../../../services/toaster.service';
import { PoojaBookedJson, DevoteeDetail } from '@otas/model/pooja/pooj-booking-response';
import { DateService } from '../../../services/date.service';
@Component({
    selector: 'app-add-payment-modal',
    templateUrl: './add-payment-modal.component.html',
    styleUrls: ['./add-payment-modal.component.css'],
    providers: [AddPaymentModalService],
    standalone: false
})
export class AddPaymentModalComponent implements OnInit {
  array:any=[];
  submitArray:any=[];
  paymentData: any = {};
  data: InvoiceDetails;
  flag;
  multiDueAmount;
  allBankList: any = [] = [];
  allAccountsList: any = [] = [];
  message;
  loading = false;
  chequeCleared = false;
  submitted = false;
  amountDue;
  isNotValidPaymentDate = false;
  datePickerOptions: any = AppConstants.paymentDatePickerOptions;
  userData: any = {};
  swipingAmount: number = 0;
  poojaInvoices: any[];
  total = 0;
  papertType = '';
  modalRef: NgbModalRef;
  constructor(public activeModal: NgbActiveModal, private fb: UntypedFormBuilder, private addPaymentModalService: AddPaymentModalService,
    private confirmModalService: ConfirmModalService, private globalUtilService: GlobalUtilService, public toastr: ToasterService
  ) {
  }

  setDatepickerOptions() {
    if (!!this.data?.invoiceAt) {
      this.datePickerOptions.startDate = new Date(this.data.invoiceAt);
    }
  }
  ngOnInit() {
    this.paymentData.paymentDate = new Date();// moment(new Date(), 'DD-MM-YYYY').toDate();
    this.setDatepickerOptions();
    this.getAllbankList();
    this.getAllAccount();
    this.paymentData.transactionType = 'CASH';


    if (!this.flag) {
      if (!this.data?.dueAmount) {
        this.amountDue = 0;
        return;
      }
      this.amountDue = this.data?.dueAmount;
      this.paymentData.paidAmount = this.data?.dueAmount;
    }
    if (!!this.flag) {
      if (this.data.paidAmount === null) {
        this.amountDue = 0;
      }
      // this.amountDue = parseInt(this.data.totalAmount, null) - parseInt(this.data.paidAmount, null);
      this.amountDue = this.data.totalAmount - this.data.paidAmount;
      this.paymentData.paidAmount = this.amountDue;
    }
  }
  changeChequeClearance(e) {
    this.chequeCleared = !!this.chequeCleared ? false : true;
  }
  checkPaidAmount(e) {

    const invalidAmount = ((parseInt(this.amountDue, null) - parseInt(e, null)) > this.data.totalAmount) ||
      ((parseInt(this.amountDue, null) - parseInt(e, null)) < 0);
    this.message = !!invalidAmount ? 'paid amount is greater than total amount' : null;
  }
  changeTransactionType(e) {
    if (e === 'CASH') {
      this.paymentData.bankAccountId = null;
      this.paymentData.chequeNo = null;
    }
    if (e === 'POS') {

      this.userData = JSON.parse(sessionStorage.getItem('CURRENT_USER'));
      this.paymentData.posCharge = ((!!this.userData.poscharge) ? this.userData.poscharge : '');
      this.paymentData.bankAccountId = (!!this.userData.poschargebank) ? this.userData.poschargebank : '';

      this.swipingAmount = (!!this.paymentData.paidAmount) ?
        ((!!this.userData.poscharge) ? (((+this.userData.poscharge * +this.paymentData.paidAmount) / 100) + +this.paymentData.paidAmount) : this.paymentData.paidAmount)
        : 0;

    }
  }
  getAllAccount() {
    this.addPaymentModalService.getAllAccount().pipe(tap(() =>
      this.loading = true), finalize(() => { this.loading = false; })).subscribe(response => {
        this.allAccountsList = response.result;

        this.paymentData.accountId = this.allAccountsList[0].id;

      });
  }
  addPayment() {
    this.isNotValidPaymentDate = false;
    if (!this.paymentData.transactionType || !this.paymentData.paidAmount || !this.paymentData.paymentDate ||
      (this.paymentData.transactionType === 'CHEQUE' && !this.paymentData.bankAccountId) ||
      (this.paymentData.transactionType === 'CHEQUE' && !this.paymentData.chequeNo)) {
      this.submitted = true;
      return;
    }

    if (moment(this.paymentData.paymentDate).isBefore(this.data.invoiceAt, 'date')) {
      this.submitted = true;
      this.isNotValidPaymentDate = true;
      return;
    }

    if (!this.flag) {

      const pDate = this.paymentData.paymentDate * 1;
      this.paymentData.paymentDate = pDate;
      this.paymentData.invoiceId = this.data.invoiceId;
      this.paymentData.chequeCleared = this.chequeCleared;
      this.paymentData.isChequeCleared = this.chequeCleared;
      this.addPaymentModalService.addPayment(this.paymentData).subscribe(response => {
        if (response.status === 'SUCCESS') {
          this.activeModal.close(true);
          this.paymentData = null;
          this.confirmModalService.confirm('Print Payment', `Do you want to print this payment ? `).result.then((res) => {
            if (!!res) {
              if (!!response.result) {
                let paymentObj = new PaymentResponseObj();
                paymentObj = response.result;
                paymentObj.printType = 'payment';
                this.globalUtilService.IPCRendererSend('handlePrintRequest', paymentObj, false);
              }
            }
          });
        }
      });

    }
    if (!!this.flag) {
      const pDate = this.paymentData.paymentDate * 1;
      this.paymentData.paymentDate = pDate;
      this.paymentData.invoiceId = this.data.invoiceId;
      this.paymentData.isChequeCleared = this.chequeCleared;
      this.addPaymentModalService.addPaymentForPoojaEnquiry(this.paymentData).subscribe(response => {
        if (response.status === 'SUCCESS') {
          this.activeModal.close(true);
          this.modalRef =
            this.confirmModalService.confirmInvoiceOrPayment('Print Confirmation', `Are you sure, you want to print payment voucher or invoice`, true, true);
          this.modalRef.result.then(result => {
            if (!!result && !!response.result) {
              if (result.status === 'invoice') {
                this.printInvoiceAfterPayment(this.paymentData.invoiceId);
              } else {
                let paymentObj = new PaymentResponseObj();
                paymentObj = response.result;
                paymentObj.printType = 'payment';
                this.globalUtilService.IPCRendererSend('handlePrintRequest', paymentObj, false);
              }
              this.paymentData = null;
            }
          });
        }
      });
    }
  }
  addPaymentMultiple() {
    this.array.forEach(element => {
      var todayString;
      var dateTime:any = moment(moment(element.transactionDate).format('YYYY-MM-DD'));
      todayString= dateTime *1 ;
      const obj = {
        invoiceId: element.id, transactionType: this.paymentData.transactionType, isChequeCleared: this.chequeCleared,
        amount: (element.totalAmount-element.paidAmount), bankAccountId: this.paymentData.bankAccountId, chequeNumber: this.paymentData.chequeNo,
        posCharge: this.paymentData.posCharge, status: "PAID", transactionDate: todayString , totalAmount: this.multiDueAmount, paidAmount: this.multiDueAmount
      }
      this.submitArray.push(obj);
    });

    this.submitArray.forEach(element => {
      if (element.transactionType === "POS") {
        element.totalAmount = this.swipingAmount;
        element.paidAmount = this.swipingAmount;
      }
    });
    this.addPaymentModalService.addPaymentSubmit(
      this.submitArray).subscribe(response => {
        this.activeModal.close();
        if(!!response&&!!response.result){
          this.print(response);
        }

       

      });
  }

  print(response){
    // _confirm(title: string, content: string, cancelButton?, confirmButtonTitle?: string, removeButton?, blockButton?, reason?, date?, invoice?)
    this.modalRef =
    this.confirmModalService.confirmInvoice('Print Confirmation', `Are you sure, you want to print voucher`, false, false, true);
    this.modalRef.result.then(result => {
  
      if (result.status === 'invoice') {
       
          const invArray  = [];
          this.submitArray.forEach(element => {
            invArray.push(element.invoiceId);
          });
          this.addPaymentModalService.getPoojaEnquiryByInvoiceIds(invArray).subscribe(response => {
            if (!response.length) {
              this.toastr.warning('No data available', 'WARNING');
            } else {
              const poojaInvoices = [];
              response.forEach(ele => {
                let poojaInvoice = new PoojaBookedJson();
                let invoice = ele.result;
                poojaInvoices.push(  this.addPaymentModalService.setInvoiceForPrint(invoice,poojaInvoice,''));
              });
             
              this.globalUtilService.IPCRendererSend('handlePrintRequest', poojaInvoices, false);
              this.modalRef.close();
            }
          });

      } else {
        let paymentObj = new PaymentResponseObj();
        paymentObj = response.result;
        paymentObj.printType = 'payment';
        this.globalUtilService.IPCRendererSend('handlePrintRequest', paymentObj, false);
      }
  });
  }
  getAllbankList() {
    !!GlobalData.menus[0].array?.length ? this.allBankList = GlobalData.menus[0].array : this.allBankList = [];
    this.addPaymentModalService.getAllbankList().subscribe(response => {
      this.allBankList = response.result;
    });
  }

  printInvoiceAfterPayment(invoiceId) {
    this.addPaymentModalService.getPoojaEnquiryByInvoiceId(invoiceId).subscribe(response => {
      if (!response.result.invoice.length) {
        this.toastr.warning('No data available', 'WARNING');
      } else {
        this.poojaInvoices = [];
        let poojaInvoice = new PoojaBookedJson();
        let invoice = response.result.invoice;
        this.poojaInvoices.push(  this.addPaymentModalService.setInvoiceForPrint(invoice,poojaInvoice,this.papertType));
        this.globalUtilService.IPCRendererSend('handlePrintRequest', this.poojaInvoices, false);
        this.modalRef.close();
      }
    });
  }

 
}
